import queryString from "query-string";

import {
    GET_PROJECT,
    GET_PROJECT_USER
} from "@/api/master-data/project/project";

const state = {
    project: [],
    projectUser: []
};

const mutations = {
    setProject: (states, payload) => {
        states.project = payload;
    },
    setProjectUser: (states, payload) => {
        states.projectUser = payload;
    },
};

const actions = {
    getProject: async ({ commit }, args) => {
        const params = queryString.stringify(args);

        try {
            const resp = await GET_PROJECT(params);
            // console.log("resppp", resp)
            if (resp.data.httpCode === 200) {
                commit("setProject", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            // console.log(resp)
            if (resp.data.httpCode === 404) {
                commit("setProject", []);
            }
            throw err;
        }
    },
    getProjectByUser: async ({ commit }, { nik, args }) => {
        try {
            const resp = await GET_PROJECT_USER(nik, args); 
            if (resp.data.httpCode === 200) {
                commit("setProjectUser", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setProjectUser", []);
            }
            throw err;
        }
    }
};

const getters = {
    Project: (states) => states.project,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};